import { render, staticRenderFns } from "./FormTicket.vue?vue&type=template&id=978a0d04"
import script from "./FormTicket.vue?vue&type=script&lang=js"
export * from "./FormTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports